// extracted by mini-css-extract-plugin
module.exports = {"block":"SchedulePage_block__p5HUb","header":"SchedulePage_header__kQeIK","title":"SchedulePage_title__jI5mB"};